import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import closeMenuIcon from "../../assets/classroom/images/classroom_bg-close-menu.png";
import { login } from "../../auth/auth";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const passphrase = process.env.REACT_APP_CLASSROOM_KEY;

const ClassroomStartMenu = ({ closeMenu }) => {
  const [authToken, setAuthToken] = useState(null);
  const [menuTitle, setMenuTitle] = useState("Select Topic");
  const [avatars, setAvatars] = useState([]);
  const [topics, setTopics] = useState([]);
  const [isTopicSelected, setIsTopicSelected] = useState(false);
  const [avatarConfig, setAvatarConfig] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    // remove this for enabling the topic selection
    setMenuTitle("Select Avatar");
    setIsTopicSelected(true);
  }, []);

  useEffect(() => {
    const fetchAvatars = async () => {
      if (!authToken) return;

      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/avatar/passphrase/${passphrase}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setAvatars(data.data || []);
        // console.log("Avatars:", data.data);
      } catch {
        // Handle error silently or add an optional error state
      }
    };

    fetchAvatars();
  }, [authToken, passphrase]);

  const fetchAvatarConfig = async () => {
    if (!authToken) return;

    try {
      const response = await axios.get(
        `${BASE_URL}/api/config/passphrase/${passphrase}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      setAvatarConfig(response.data.data || []);
    } catch (error) {
      console.error("Failed to fetch avatar config ID:", error);
    }
  };

  useEffect(() => {
    fetchAvatarConfig();
  }, [authToken, passphrase]);

  const handleAvatarSelect = (avatar) => {
    const getId = avatar.id;
    console.log("Avatar ID:", getId);

    const avatarlanguage =
      sessionStorage.getItem("language") === "EN" ? "English" : "Indonesia";

    const matchingConfig = avatarConfig.find(
      (item) => item.language === avatarlanguage && item.avatar.id === getId
    );

    if (matchingConfig) {
      const configId = matchingConfig.id;
      console.log("Matching Config ID:", configId);
      sessionStorage.setItem("id", configId);
      sessionStorage.setItem("AvatarName", avatar.name);

      const currentPath = window.location.pathname;
      navigate(`${currentPath}/${encodeURIComponent(avatar.name)}`);
    } else {
      console.error(
        "No matching config found for the selected avatar and language."
      );
    }
  };

  const SubmenuAvatar = () => (
    <div className={`submenu__avatar ${avatars.length > 1 ? "avatars" : ""}`}>
      {avatars.map((avatar, index) => (
        <div
          className="submenu__item-avatar"
          key={index}
          onClick={() => handleAvatarSelect(avatar)}
        >
          <div className="avatar-container">
            <img src={`${BASE_URL}${avatar.hyperlink}`} alt={avatar.name} />
          </div>
          <div className="avatar-name">
            <p>{avatar.name}</p>
          </div>
        </div>
      ))}
    </div>
  );

  const SubmenuTopic = () => (
    <div className="submenu__topic">
      {topics.map((topic, index) => (
        <div
          className="submenu__item-topic"
          key={index}
          onClick={() => handleTopicSelect(topic)}
        >
          <p>{topic}</p>
        </div>
      ))}
    </div>
  );

  const handleTopicSelect = (topic) => {
    setMenuTitle(`Select Avatar`);
    setIsTopicSelected(true);
  };

  useEffect(() => {
    const fetchTopics = async () => {
      if (!authToken) return;

      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/config/passphrase/${passphrase}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setTopics(data.data?.[0]?.key?.name ? [data.data[0].key.name] : []);
      } catch {
        // error handling
      }
    };

    fetchTopics();
  }, [authToken, passphrase]);

  return (
    <div className="menu__classroom">
      <div className="menu__navbar">
        <h1 className="menu__title">{menuTitle}</h1>
        <div className="close-menu" onClick={closeMenu}>
          <img src={closeMenuIcon} alt="Close Menu" />
        </div>
      </div>

      <div className="menu__content">
        {isTopicSelected ? <SubmenuAvatar /> : <SubmenuTopic />}
      </div>
    </div>
  );
};

export default ClassroomStartMenu;
